
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'
import CircularLogo from '../CircularLogo'
import { ASSET_BASE_URL } from 'config'
import successIcon from './success.svg'
import errorIcon from './error.svg'
import classnames from 'classnames'

const ConnectingLoader = props => {
  const { logo, name, isConnecting, isConnected, isErrored } = props

  const classes = classnames({
    [css.main]: true,
    [css.isConnecting]: isConnecting,
    [css.isConnected]: isConnected && !isConnecting,
    [css.isErrored]: isErrored && !isConnecting
  })

  return (
    <div className={classes}>
      <div className={css.logo}>
        <CircularLogo logo={`${ASSET_BASE_URL}/logos/segment-icon.svg`} alt='Segment' />
      </div>

      <div className={css.dots}>
        <div className={css.dot} />
        <div className={css.dot} />
        <div className={css.dot} />
      </div>

      <div className={css.logo}>
        <CircularLogo logo={logo} alt={name} />
        <img className={`${css.statusIcon} ${css.successIcon}`} src={successIcon} alt='' />
        <img className={`${css.statusIcon} ${css.errorIcon}`} src={errorIcon} alt='' />
      </div>
    </div>
  )
}

ConnectingLoader.propTypes = {
  isConnected: PropTypes.bool,
  isConnecting: PropTypes.bool,
  isErrored: PropTypes.bool,
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

ConnectingLoader.displayName = 'ConnectingLoader'

export default ConnectingLoader



// WEBPACK FOOTER //
// ./ui/ConnectingLoader/index.js